import React from 'react';
import { Row, Col } from 'antd';

import { TitleForm } from './TitleForm';
import { useEvaluation } from '../hooks/useEvaluation';
import { TaskCard } from '../../../components/TaskCard';
import { Pagination } from '../../../components/Pagination';

interface EvaluationFormProps {
	goToSubStep: (step: number) => void;
}

export function EvaluationForm({ goToSubStep }: Readonly<EvaluationFormProps>): JSX.Element {
	const {
		isXl,
		limit,
		currentPage,
		isLoading,
		paginated_activities,
		files_activities,
		handleSetPage,
		handleInputChange,
		addItem,
		handleChange,
		getAvailableOptions
	} = useEvaluation({ goToSubStep });

	return (
		<Row gutter={[16, 16]}>
			<Col span={24} style={{ marginBottom: '20px' }}>
				<TitleForm title="Evaluation" subtitle="Identify tasks and carry out their evaluation." />
			</Col>
			{paginated_activities?.map((activity: any, index: number) => (
				<Col key={activity.file_id} md={isXl ? 8 : 12} sm={24}>
					<TaskCard
						idx={index}
						activityId={activity.activity_id || null}
						fileId={activity.file_id}
						assessmentId={activity.assessment_id}
						image={activity.image}
						fileName={activity.file_name}
						status={activity.status}
						options={getAvailableOptions(index)}
						goToSubStep={goToSubStep}
						handleInputChange={handleInputChange}
						addItem={addItem}
						handleChange={handleChange}
						isLoading={isLoading}
					/>
				</Col>
			))}
			<Col span={24}>
				<Pagination
					limit={limit}
					currentPage={currentPage}
					total={files_activities.length}
					onChangePage={handleSetPage}
				/>
			</Col>
		</Row>
	);
}
